// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","header":"_229sT6ABi5LaWblkZ-kP2m"};